(() => {
  const SELECTOR = '[data-hindi-banner-slider]';

  function initSlider(root) {
    if (!root || root.dataset.sliderInitialized === 'true') return;

    const track = root.querySelector('[data-slider-track]');
    const slides = Array.from(root.querySelectorAll('[data-slider-slide]'));
    const previousButton = root.querySelector('[data-slider-previous]');
    const nextButton = root.querySelector('[data-slider-next]');
    const dots = Array.from(root.querySelectorAll('[data-slider-dot]'));

    if (!track || slides.length === 0) return;

    root.dataset.sliderInitialized = 'true';

    let currentIndex = 0;
    let autoplayTimer = null;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchTracking = false;

    const autoplayEnabled = root.dataset.autoplay === 'true' && slides.length > 1;
    const pauseOnHover = root.dataset.pauseOnHover === 'true';
    const autoplaySpeed = Math.max(Number(root.dataset.autoplaySpeed) || 5000, 3000);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function normalizeIndex(index) {
      return (index + slides.length) % slides.length;
    }

    function render(index) {
      currentIndex = normalizeIndex(index);
      track.style.transform = `translate3d(${-currentIndex * 100}%, 0, 0)`;

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === currentIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
        dot.tabIndex = isActive ? 0 : -1;
      });
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled || reducedMotion || document.hidden) return;
      autoplayTimer = window.setInterval(() => render(currentIndex + 1), autoplaySpeed);
    }

    function goTo(index, restart = true) {
      render(index);
      if (restart) startAutoplay();
    }

    previousButton?.addEventListener('click', () => goTo(currentIndex - 1));
    nextButton?.addEventListener('click', () => goTo(currentIndex + 1));

    dots.forEach((dot) => {
      dot.addEventListener('click', () => goTo(Number(dot.dataset.sliderDot) || 0));
    });

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(currentIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(currentIndex + 1);
      }
    });

    root.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      if (!touch) return;
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      touchTracking = true;
      stopAutoplay();
    }, { passive: true });

    root.addEventListener('touchend', (event) => {
      if (!touchTracking) return;
      touchTracking = false;
      const touch = event.changedTouches[0];
      if (!touch) {
        startAutoplay();
        return;
      }

      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;

      if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY)) {
        goTo(deltaX < 0 ? currentIndex + 1 : currentIndex - 1);
      } else {
        startAutoplay();
      }
    }, { passive: true });

    if (pauseOnHover) {
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
    }

    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) startAutoplay();
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    render(0);
    startAutoplay();
  }

  function initAll(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest(SELECTOR);
    if (!root) return;
    const selectedSlide = event.target.closest('[data-slider-slide]');
    if (!selectedSlide) return;
    const dot = root.querySelector(`[data-slider-dot="${selectedSlide.dataset.slideIndex}"]`);
    dot?.click();
  });
})();
